import { observable, action, runInAction } from "mobx";
import moment from "moment";
import _ from "lodash";
import http from "../../util/http";
class InactiveList {
  @observable
  agentList = [];
  @observable
  dateStart = null;
  @observable
  dateEnd = null;
  @observable
  sort = 0;
  @observable
  weeks = 1;
  @observable
  loading = false;

  @action
  async getAgentList() {
    try {
      runInAction(() => {
        this.loading = true;
        this.agentList = [];
      });
      const inactiveListPayload = JSON.stringify({
        Ds:
          _.toString(
            moment().day(1).subtract(this.weeks, "weeks").format("YYYY-MM-DD")
          ) + " 00:00:00.000",
        De: _.toString(moment().day(0).format("YYYY-MM-DD")) + " 23:59:59.000",
        sort: this.sort,
      });
      const agentList = await http.sendHelperCommand(
        "InactiveAgentListHelper.aspx",
        { payload: inactiveListPayload }
      );
      // const agentList = await http.sendCommand("command:agent:inactiveList", {
      runInAction(() => {
        this.agentList = agentList;
        this.loading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.agentList = [];
        this.loading = false;
      });
    }
  }

  handleDropdown(type, value) {
    if (type === "weeks") {
      this.weeks = value;
    } else {
      this.sort = value;
    }
  }
}

export default new InactiveList();
